import Vue from "vue";

const state = {
    diceAPI: undefined,
};

const getters = {
    diceAPI(state) {
        return state.diceAPI;
    },
};

const mutations = {
    setDiceAPIConfig(state, config) {
        state.diceAPI = config;
    },
};

const actions = {
    async getDiceAPIConfig({ commit }) {
        try {
            const response = await Vue.prototype.$diceAPI.getConfig();
            commit("setDiceAPIConfig", response.data);
        } catch (e) {
            commit("setDiceAPIConfig", null);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};